import { LoginForm } from '@/features/auth';
import { FormWrapper } from '@/components/layouts';

export function LoginPage () {
    return (
        <FormWrapper>
            <LoginForm />
        </FormWrapper>
    )
}